import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import homeReducer from "./homeReducer";
import userReducer from "./userReducer";
import adminReducer from "./adminReducer";
import chapterReducer from "./chapterReducer";

const createRootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    homeReducer,
    userReducer,
    adminReducer,
    chapterReducer
  });

export default createRootReducer;
